import { GtmService } from '~/src/services/web-analytics.service';
import { getAnalyticsEventData } from '~/src/helpers/web-analytics-events-data.helper';
import {
    WebAnalyticsActionGroupEnum,
    WebAnalyticsEventActionEnum,
    WebAnalyticsEventCategoryEnum,
    WebAnalyticsEventEnum,
} from '~/src/models/enums/web-analytics.enum';

//TODO Done
export const onSendSuccessRequestEventAnalytics = () => {
    GtmService.send(
        getAnalyticsEventData({
            eventAction: WebAnalyticsEventActionEnum.confirmed,
            eventLabel: 'uspeh_otpravki_zayavki',
            event: WebAnalyticsEventEnum.vntForm,
            eventCategory: WebAnalyticsEventCategoryEnum.createNewLeadRef,
            actionGroup: WebAnalyticsActionGroupEnum.interactions,
        }),
    );
};

export const onSendErrorRequestEventAnalytics = () => {
    GtmService.send(
        getAnalyticsEventData({
            eventAction: WebAnalyticsEventActionEnum.rejected,
            eventLabel: 'oshibka_otpravki_zayavki',
            event: WebAnalyticsEventEnum.vntForm,
            eventCategory: WebAnalyticsEventCategoryEnum.createNewLeadRef,
            actionGroup: WebAnalyticsActionGroupEnum.interactions,
        }),
    );
};
